module.exports = "<div id=\"root\" class=\"ember-application\">\n  <div id=\"ember348\" class=\"ember-view\">\n\n    <!--Header goes here-->\n    <app-header [hidden]=\"isHeaderHidden\"></app-header>\n\n    <router-outlet></router-outlet>\n\n\n  </div>\n</div>\n<app-footer></app-footer>\n\n<app-alert-message></app-alert-message>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/main/app.component.html
// module id = 560
// module chunks = 0